export enum RemoteMenuType {
  None = 0,
  Default = 1,
  Remote = 2
}
